import { render, staticRenderFns } from "./Phone.vue?vue&type=template&id=714e16ff&scoped=true"
import script from "./Phone.vue?vue&type=script&lang=js"
export * from "./Phone.vue?vue&type=script&lang=js"
import style0 from "./Phone.vue?vue&type=style&index=0&id=714e16ff&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714e16ff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/muying-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('714e16ff')) {
      api.createRecord('714e16ff', component.options)
    } else {
      api.reload('714e16ff', component.options)
    }
    module.hot.accept("./Phone.vue?vue&type=template&id=714e16ff&scoped=true", function () {
      api.rerender('714e16ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/page/modules/phone/Phone.vue"
export default component.exports